import {GetAllCountriesResponse} from '@/types/Countries'
import {getAllCountriesService} from '../services/notificationsService'

export type GetAllTraitsUseCaseParams = {
  traitType: string
}

export async function getAllCountriesUseCase(signal?: AbortSignal): Promise<GetAllCountriesResponse> {
  return getAllCountriesService(signal)
}
